import { Component } from '@angular/core';
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { IAppState } from 'src/app/store/states/app.state';
import { pinblocksGen } from "src/app/utils/utils";
import { CobranzaService } from "src/app/services/cobranza.service";
import { LoadClientOkFailed } from '../../cobranza-digital/store/actions/clientOk.action';
import { catchError, throttleTime } from 'rxjs/operators';
import { fromEvent } from 'rxjs';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent {
  idDocument : string = "";
  typeDc : string = "";
  public origin: string = "";
  origintrace = null;
  error = false;
  private static readonly CLICK_THROTTLE_TIME_MS = 3000;


  constructor(
    private readonly cobranzaService: CobranzaService,
    private readonly router: Router,
		private readonly _store: Store<IAppState>,
  ) { }

  ngOnInit(): void {
		sessionStorage.clear();
    const buttonIngresar = document.getElementById("btn-simula-banner") as HTMLButtonElement;
    const buttonIngresarClick$ = fromEvent(buttonIngresar, 'click');

    buttonIngresarClick$.pipe(
        throttleTime(BannerComponent.CLICK_THROTTLE_TIME_MS),
    ).subscribe(
      () => {
        this.simular();
      }
    );
  }

  simular(){
    if(this.idDocument !== "" && this.typeDc !== "" && this.origin !==""){
      this.cobranzaService.generateAuthCode(this.idDocument, pinblocksGen(this.idDocument), this.typeDc)
      .pipe(
        catchError(e => {
          this._store.dispatch(new LoadClientOkFailed(e));
          console.info("Error en validacion, Validar NUMERO y TIPO de documento");
          this.error = true;
          throw e;
        })
      )
      .subscribe({
        next: (response) => {
          const cod: string = response['authorizationCode'];
          if(this.origin==="0"){
            this.origintrace = "&trace=pruebatrace"
          }

          this.router.navigate([""], {
            queryParams: {
              code: cod,
              trace: this.origintrace
            }
          });
        }
      });
  }

  }
  onChangeValue($event:string){
    this.origin = $event;
  }
}
